export const novasolInspiration = {
    rightSection: {
        title: 'Ferier for alle',
        footerLink: {
            title: 'Se alle ferietyper',
            href: '/ferie',
        },
        isImageLinks: true,
        links: [
            {
                title: 'Sommerhus med hund',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/1Ip8BpvBsyRs1DM3pJN1IR/f49406ecb7069a652c264902d6d5571d/andrew-pons-QsmGE0P2-B8-unsplash.jpg?w=191&h=142&fm=webp',
                    alt: 'Sommerhus med hund',
                },
                link: {
                    href: '/ferie/ferie-med-hund',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Last minute sommerhus',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/2qGGA5v6RFFSwpaoFQ9Ocd/c417b6a59c708b938ca3bf03d8cea1a9/NOVASOL_2902.jpg?w=191&h=141&fm=webp',
                    alt: 'Last minute sommerhus',
                },
                link: {
                    href: '/ferie/last-minute',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Sommerhus ved havet',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/4VyHRfO5XQaxux6ST6Dlro/985317f72fee66c74da8d071874a24d2/AdobeStock_566575402.jpeg?w=191&h=141&fm=webp',
                    alt: 'Sommerhus ved havet',
                },
                link: {
                    href: '/ferie/ferie-ved-havet',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'All inclusive',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/1XWPEWm2tlrw8jHFQ6n9Yf/4189500dbccd3e4d161fe6bef7b6ac06/AdobeStock_449703512.jpeg?w=191&h=141&fm=webp',
                    alt: 'All inclusive',
                },
                link: {
                    href: '/ferie/all-inclusive',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Kør selv ferie',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/1c662Ii42hFQClqneutqA5/15a83e37069dd10aa44f50d31dd78a6d/NOVASOL_2257.jpg?w=191&h=141&fm=webp',
                    alt: 'Kør selv ferie',
                },
                link: {
                    href: '/ferie/koer-selv-ferie',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Sommerhus med pool',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/meVvCn5ZqKflNlaKdDkAi/25871676563d8fc20b8f89efeb0947f6/NOVASOL_3243.jpg?w=191&h=141&fm=webp',
                    alt: 'Sommerhus med pool',
                },
                link: {
                    href: '/ferie/feriehuse-med-pool',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Luksussommerhuse',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/4TFZEKWiJ86QOaO22WDlLg/38ca446c116bc7e60de8276be1683474/pexels-michael-block-3225531.jpg?w=300&h=300&fm=webp',
                    alt: 'Luksussommerhuse',
                },
                link: {
                    href: '/ferie/luksus-sommerhuse',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Miniferie',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/32qTbat6tiPscFYyNwjNrK/be7d0046adac65079e16488d1ba261fa/NOVASOL_1067.jpg?w=191&h=141&fm=webp',
                    alt: 'Miniferie',
                },
                link: {
                    href: '/ferie/miniferie',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Ødegårde',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/7nfhruIEIJPCWqAYhx1QP8/6fd150502130a9666e402bd05f6899ad/pexels-monicore-141876.jpg?w=300&h=300&fm=webp',
                    alt: 'Ødegårde',
                },
                link: {
                    href: '/ferie/oedegaard',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Husbåde',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/6inAbDwtY3k1UXlCLq6VAu/55e0c425f2146eec6a871c01cc8128f3/remi-bertogliati-yF2D6McgL0k-unsplash__1_.jpg?w=300&h=300&fm=webp',
                    alt: 'Husbåde',
                },
                link: {
                    href: '/ferie/husbaade',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
export const novasolDestinations = {
    leftSection: {
        title: 'Udforsk vores destinationer',
        isMultiColumns: true,
        links: [
            {
                link: {
                    title: 'Belgien',
                    href: '/belgien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Cypern',
                    href: '/cypern',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Danmark',
                    href: '/danmark',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Frankrig',
                    href: '/frankrig',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Grækenland',
                    href: '/graekenland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Holland',
                    href: '/holland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Italien',
                    href: '/italien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Kroatien',
                    href: '/kroatien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Luxembourg',
                    href: '/luxembourg',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Montenegro',
                    href: '/montenegro',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Norge',
                    href: '/norge',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Polen',
                    href: '/polen',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Portugal',
                    href: '/portugal',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Slovenien',
                    href: '/slovenien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Spanien',
                    href: '/spanien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Sverige',
                    href: '/sverige',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Tyskland',
                    href: '/tyskland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Østrig',
                    href: '/oestrig',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
    rightSection: {
        title: 'Mest populære steder',
        isImageLinks: false,
        links: [
            {
                title: 'Algarve',
                link: {
                    href: '/portugal/algarve',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Anholt',
                link: {
                    href: '/danmark/oestjylland/anholt',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Blokhus',
                link: {
                    href: '/danmark/nordjylland/blokhus',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Bornholm',
                link: {
                    href: '/danmark/bornholm',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Fanø',
                link: {
                    href: '/danmark/fanoe',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Gardasøen',
                link: {
                    href: '/italien/gardasoen',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Gudhjem',
                link: {
                    href: '/danmark/bornholm/gudhjem',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Harzen',
                link: {
                    href: '/tyskland/harzen',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Hvide Sande',
                link: {
                    href: '/danmark/vestjylland/hvide-sande',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Kreta',
                link: {
                    href: '/graekenland/kreta',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Langeland',
                link: {
                    href: '/danmark/langeland-taasinge',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Løkken',
                link: {
                    href: '/danmark/nordjylland/loekken',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Malaga',
                link: {
                    href: '/spanien/andalusien/malaga',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Mallorca',
                link: {
                    href: '/spanien/mallorca',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Marielyst',
                link: {
                    href: '/danmark/falster/marielyst',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Provence',
                link: {
                    href: '/frankrig/provence',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Rømø',
                link: {
                    href: '/danmark/roemoe',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Samsø',
                link: {
                    href: '/danmark/oestjylland/samsoe',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Sicilien',
                link: {
                    href: '/italien/sicilien',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Skagen',
                link: {
                    href: '/danmark/nordjylland/skagen',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Toscana',
                link: {
                    href: '/italien/toscana',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Vesterhavet',
                link: {
                    href: '/danmark/vesterhavet',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
//# sourceMappingURL=da.js.map